import { Box, Button, Typography } from "@mui/material";
import { DeliveryTruckIcon } from "../../icons";
import { DetailsView } from "../SummaryCard/DetailsView";
import { SummaryBox } from "../SummaryCard/SummaryBox";
import { SummaryCardWithButtonProps } from "./SummaryCardWithButton.types";

export function SummaryCardWithButton({ title = "-", onClick = () => {}, info = "total users", color, buttonTitle = "Activate" }: SummaryCardWithButtonProps) {
  return (
    <SummaryBox color={color}>
      <DetailsView info={info} title={title} />
      <Button
        onClick={onClick}
        variant="contained"
        color="primary"
        sx={{
          textTransform: "uppercase",
          fontSize: "0.625rem",
          padding: "0.5625rem",
          position: "absolute",
          right: "1rem",
          top: "1.25rem",
          fontWeight: 500,
          borderRadius: "0.625rem",
        }}
      >
        {buttonTitle}
      </Button>
    </SummaryBox>
  );
}
